import type { IVocalise } from './vocalise';
import { vocaliseSchema } from './vocalise';
import { actionCreator, Joi, objectSchemaOf } from '../helpers';

export const NEW = 'VOCALISE/NEW';

export interface INewAction {
  type: typeof NEW;
  payload: IVocalise;
}

export const newActionSchema = objectSchemaOf<INewAction>({
  type: Joi.string().required().valid(NEW),
  payload: vocaliseSchema.required(),
});

export const newVocalise = actionCreator({
  type: NEW,
  schema: newActionSchema,
});
